import defaultAvatar from "@/assets/default-avatar.svg";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  src?: string | null;
  alt: string;
  className?: string;
}

export function UserAvatar({ src, alt, className }: UserAvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn("rounded-full object-cover bg-neutral-200", className)}
        referrerPolicy="no-referrer"
      />
    );
  }

  return (
    <div className={cn("rounded-full bg-gray-400", className)}>
      <img src={defaultAvatar} className="size-full object-cover" alt={alt} referrerPolicy="no-referrer" />
    </div>
  );
}
